import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import DisclosureCounselingRepository from '@/repositories/disclosureCounselingRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import { DscdtlResponce } from '@/models/disclosureCounseling/disclosureCounselingModel';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useDisclosureCounselingDetailStore = defineStore({
    id: 'disclosureCounselingDetail',
    state: () => ({
        disclosureCounselingDetail: new DscdtlResponce(),
        SessionGrpPk: '',
    }),
    getters: {},
    actions: {
        /**
         * 開示カウンセリング詳細取得API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getDisclosureCounselingDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const disclosureCounselingRepository = new DisclosureCounselingRepository();

            try {
                const response = await disclosureCounselingRepository.getDisclosureCounselingDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.disclosureCounselingDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 開示カウンセリング取消API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async deleteDisclosureCounselingAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const disclosureCounselingRepository = new DisclosureCounselingRepository();
            try {
                const response = await disclosureCounselingRepository.deleteDisclosureCounselingApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'delete', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.disclosureCounselingDetail = new DscdtlResponce();
            this.SessionGrpPk = '';
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
